const Metrics = {
	tabBarHeight: '60px',
	baseMargin: '1rem',
	tabletWidth: '768px',
	smallDeviceWidth: '320px',
	windowHeight: `${window.innerHeight}px`,
};

export default Metrics;
